import { render, staticRenderFns } from "./returcustomerfrm.vue?vue&type=template&id=7dbea596"
import script from "./returcustomerfrm.vue?vue&type=script&lang=js"
export * from "./returcustomerfrm.vue?vue&type=script&lang=js"
import style0 from "./returcustomerfrm.vue?vue&type=style&index=0&id=7dbea596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports